import Config from '../vessel/provider/config'
import render from '../vessel/methods/render'
import patch  from './patch'

import { hasProp } from 'vessel/utils'

const propMapping = {
  backgroundColor:   'backgroundColors',
  fill:              'backgroundColors',
  activeColor:       'backgroundColors',
  inactiveColor:     'backgroundColors',
  voidColor:         'backgroundColors',
  disabledVoidColor: 'backgroundColors',
  colors:            'backgroundColors',
  color:             'backgroundColors',
  background:        'backgroundColors',
  textColor:         'textColors',
  activeTextColor:   'textColors'
}

const iconProps = [
  'icon',
  'activeIconClass',
  'inactiveIconClass',
  'prefixIcon',
  'suffixIcon',
  'clearIcon',
  'iconClasses',
  'voidIconClass',
  'disabledVoidIconClass',
  'iconClass',
  'separatorClass'
]

// BUG: https://github.com/vuejs/vue/issues/7710
// TODO: Remove when vue adds support for slots in children

export function mapSlots(h, slots) {
  return Object.keys(slots).map(name => {
    return h('template', { slot: name }, slots[name])
  })
}

function resolvePropValue(origValue, values) {
  if (origValue && hasProp(origValue, values))
    origValue = values[origValue]

  return origValue
}

function resolveIconValue(value) {
  if (value && !value.startsWith('el-icon'))
    value = `el-icon-uil uil uil-${value} vs-icon`

  return value
}

function resolveProps(props) {
  return Object.entries(props).reduce((result, [prop, value]) => {
    let resolvedValue = value

    if (hasProp(prop, propMapping)) {
      const config = propMapping[prop]
      const values = Config[config] || {}

      if (Array.isArray(value))
        resolvedValue = value.map(item => resolvePropValue(item, values))
      else
        resolvedValue = resolvePropValue(value, values)
    } else if (iconProps.includes(prop)) {
      if (Array.isArray(value))
        resolvedValue = value.map(item => resolveIconValue(item))
      else
        resolvedValue = resolveIconValue(value)
    }

    result[prop] = resolvedValue
    return result
  }, {})
}

export default function registerComponent(component, newName) {
  const baseName = component.name.replace(/^El/, '')
  const wrapName = `Vs${newName || baseName}`

  patch(baseName, component)

  const options = {
    name: wrapName,
    props: {
      ...component.props
    },
    functional: true,
    render(h, { data, slots, props }) {
      const propData = resolveProps(props)
      const slotsMap = mapSlots(h, slots())

      return render(h, component, { ...data, props: propData }, slotsMap)
    }
  }

  return options
}
